__turbopack_context__.v({
  "blue": "I-Gabq_blue",
  "circle": "I-Gabq_circle",
  "iLine": "I-Gabq_iLine",
  "iPoint": "I-Gabq_iPoint",
  "infoIcon": "I-Gabq_infoIcon",
  "orange": "I-Gabq_orange",
  "white": "I-Gabq_white",
  "whiteGreen": "I-Gabq_whiteGreen",
  "whiteMagenta": "I-Gabq_whiteMagenta",
});
